import { render, staticRenderFns } from "./CCG.vue?vue&type=template&id=2c258af2&"
import script from "./CCG.vue?vue&type=script&lang=js&"
export * from "./CCG.vue?vue&type=script&lang=js&"
import style0 from "./CCG.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports